// extracted by mini-css-extract-plugin
module.exports = {"rectPositive":"dhvkv7Ak","rectNegative":"FNG0HKEA","rectNeutral":"ll2EPdOj"};